function required<Value extends any = string>(value: Value): string {
    if (Array.isArray(value)) {
        return value.length ? '' : 'Required';
    }
    return value ? '' : 'Required';
}

export default required;
